import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'contrastColor' })
export class ContrastColorPipe implements PipeTransform {

  /**
   * Calculates the contrast color (black or white) for a given hex color.
   * Uses the WCAG formula for relative luminance.
   *
   * @param value - Hex color string (e.g., '#FF0000' or 'FF0000')
   * @returns '#fff' for dark backgrounds, '#000' for light backgrounds
   */
  transform(value: string | null | undefined): string {
    // Handle null/undefined or empty strings
    if (!value) {
      return '#000';
    }

    // Remove '#' prefix if present
    const hex = value.replace('#', '');

    // Validate hex format
    const rgb = hex.match(/.{2}/g);
    if (!rgb || rgb.length !== 3) {
      return '#000';
    }

    // Parse RGB values
    const values = rgb.map(x => parseInt(x, 16));

    // Calculate brightness using WCAG formula
    const brightness = Math.round(
      (values[0] * 299 + values[1] * 587 + values[2] * 114) / 1000
    );

    // Return white for dark backgrounds, black for light backgrounds
    return brightness < 150 ? '#fff' : '#000';
  }

}
